export interface MappingRepairGate {
  enabled: boolean;
  autoRepair: boolean;
  projectKey: string | null;
  catalogReady: boolean;
  catalogLoading: boolean;
  repairableCount: number;
  repairKindCount: number;
  alreadyAttempted: boolean;
  repairInFlight: boolean;
}

export function shouldStartMappingRepair(gate: MappingRepairGate): boolean {
  return (
    gate.enabled &&
    gate.autoRepair &&
    Boolean(gate.projectKey) &&
    gate.catalogReady &&
    !gate.catalogLoading &&
    gate.repairableCount > 0 &&
    gate.repairKindCount > 0 &&
    !gate.alreadyAttempted &&
    !gate.repairInFlight
  );
}
